import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { MaterialApiService } from 'features/material-details/api/material-api.services';
import { UserListParams } from 'features/users';
import qs from 'qs';

import { MaterialQueryKeys } from './query-keys';

const { getMaterialDetail } = MaterialApiService();

const getUsersQuery = (
  params: UserListParams,
  options?: UseQueryOptions<any>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<any>;
  options?: UseQueryOptions<any>;
} => ({
  queryKey: MaterialQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getMaterialDetail(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetMaterialDetailList = (
  params: UserListParams,
  options?: UseQueryOptions<any>,
) => {
  const { message } = App.useApp();
     
  return useQuery<any, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};








